import { PropTypes } from 'prop-types';
import { Table } from 'ypf-pas-general-ui-components';

import columns from './columns';
import styles from './DuplicatedRequestTable.module.scss';

const DuplicatedRequestTable = ({ data }) => (
  <div className={styles['duplicated-request-table']}>
    <p className={styles['table-header-text']}>
      Existen Solicitudes con la misma ubicación, servicio para esas fechas. Notifique en la
      solicitud existente.
    </p>
    <div className={styles['duplicated-container-table']}>
      <Table columns={columns} data={data} titleLeft type="light" />
    </div>
  </div>
);

DuplicatedRequestTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired
};

export default DuplicatedRequestTable;
